import React, { memo } from "react";
import { HalfCard } from "@swiggy-private/dls-web-core/dist/components/HalfCard";

import GenerateBillContent from "./GenerateBillContent";
import { IGenerateBillConfirmationProps } from "./types";

const GenerateBillConfirmation = memo(
    ({ show, onHide, onPrimaryClick }: IGenerateBillConfirmationProps) => {
        return (
            <HalfCard isOpen={show} onClose={onHide} backgroundColor="canvas_Primary">
                <GenerateBillContent onPrimaryAction={onPrimaryClick} />
            </HalfCard>
        );
    }
);

GenerateBillConfirmation.displayName = "GenerateBillConfirmation";

export default GenerateBillConfirmation;
